// src/pages/Cerez_Politikasi.jsx
import React from "react";

const Cerez_Politikasi = () => {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>ÇEREZ POLİTİKASI</h1>

        <section style={styles.section}>
          <h2 style={styles.heading}>1. Amaç ve Kapsam</h2>
          <p style={styles.text}>
            Bu Çerez Politikası, web sitemizi ziyaret eden kullanıcıların cihazlarında saklanan
            çerezlere ilişkin esasları açıklamak amacıyla hazırlanmıştır. Web sitemiz, kullanıcı
            deneyimini geliştirmek, site performansını analiz etmek ve güvenli bir kullanım sunmak
            için çerezleri kullanır. Reklam, kişisel veri takibi veya profilleme amacıyla çerez
            kullanılmamaktadır.
          </p>
          <p style={styles.text}>
            Web sitemizde yalnızca kurumsal hesap girişi bulunmaktadır. Bunun dışında erişilen
            içerikler anonim kullanıcılar tarafından görüntülenebilir. Kullanıcı verileri hiçbir
            şekilde ticari amaçlarla veya üçüncü taraflarla paylaşılmamaktadır.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>2. Çerez Nedir?</h2>
          <p style={styles.text}>
            Çerezler, ziyaret edilen internet siteleri tarafından cihazlara kaydedilen küçük metin
            dosyalarıdır. Bu dosyalar; ziyaretçilere ait belirli bilgileri saklayarak internet
            deneyimlerinin kişiselleştirilmesine veya gelişmiş hizmet sunulmasına imkan tanır.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>3. Kullanılan Çerez Türleri</h2>
          <p style={styles.text}>Web sitemizde aşağıda belirtilen çerez türleri kullanılabilir:</p>
          <ul style={styles.list}>
            <li>
              <strong>Zorunlu (Gerekli) Çerezler:</strong> Web sitesinin temel fonksiyonlarını
              çalıştırmak için gereklidir. Oturum açma, güvenlik ve sayfa dolaşımı gibi temel
              işlevleri sağlar. Bu çerezler olmadan web sitesi sağlıklı şekilde çalışamaz.
            </li>
            <li>
              <strong>Performans ve Analitik Çerezler:</strong> Ziyaretçilerin siteyi nasıl
              kullandığına ilişkin anonim bilgileri toplar. Bu bilgiler, sitemizin performansını ve
              kullanıcı deneyimini iyileştirmek amacıyla kullanılır. Bu çerezler kişisel veri
              içermemekte olup, kullanıcı kimlik bilgisi ile eşleştirilmez.
            </li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>4. Kullanılmayan Çerez Türleri</h2>
          <p style={styles.text}>
            Şeffaflık amacıyla aşağıdaki çerez türlerinin kullanılmadığını açıkça belirtiriz:
          </p>
          <ul style={styles.list}>
            <li>Reklam ve pazarlama çerezleri</li>
            <li>Davranışsal hedefleme çerezleri</li>
            <li>Üçüncü taraf reklam çerezleri</li>
          </ul>
          <p style={styles.text}>
            Kullanıcı verileri reklam amaçlı kullanılmaz ve kullanıcı profillemesi yapılmaz.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>5. Çerezlerin Yönetimi</h2>
          <p style={styles.text}>
            Ziyaretçiler, tarayıcı ayarları aracılığıyla çerez kullanımını kontrol edebilir,
            çerezleri silebilir veya tamamen devre dışı bırakabilir. Ancak bu durumda web sitesinin
            bazı fonksiyonlarının düzgün çalışmaması mümkündür.
          </p>
          <p style={styles.text}>
            Çerez ayarlarını değiştirme yöntemleri kullanılan tarayıcıya göre değişiklik
            gösterebilir. Tarayıcı ayarları menüsünden çerez tercihleri yönetilebilir.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>6. Kişisel Verilerin Korunması</h2>
          <p style={styles.text}>
            Çerezler aracılığıyla elde edilen veriler, kişisel veri niteliğinde olduğunda ilgili
            mevzuat kapsamında korunur. Kişisel veriler yalnızca kullanıcıların açık rızası ve ilgili
            veri koruma kanunlarına uygun şekilde işlenir.
          </p>
          <p style={styles.text}>
            Web sitemizde kurumsal hesap girişi yapan kullanıcıların verileri güvenli bir şekilde
            saklanır ve yetkisiz erişime karşı korunur.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>7. Veri Saklama Süresi</h2>
          <p style={styles.text}>
            Çerezler, kullanım amaçlarına ve türlerine göre tarayıcı veya cihaz üzerinde belirli
            sürelerle saklanabilir. Bu süre sona erdiğinde çerezler otomatik olarak silinir.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>8. Değişiklikler</h2>
          <p style={styles.text}>
            Bu Çerez Politikası gerektiğinde güncellenebilir. Güncellemeler web sitesi üzerinden
            yayımlandığı tarihten itibaren geçerlilik kazanır.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>9. İletişim</h2>
          <p style={styles.text}>
            Çerez politikası ile ilgili tüm soru ve talepleriniz için bizimle iletişime
            geçebilirsiniz:
          </p>
          <p style={styles.text}>
            E-posta: <a href="mailto:info@vondigital.com.tr" style={styles.link}>info@vondigital.com.tr</a>
            <br />
            Adres: Göztepe Mah. Mithatpaşa Cad. Gürsoy No: 856/1B Konak/İzmir
          </p>
        </section>
      </div>
    </div>
  );
};

const styles = {
  page: {
    backgroundColor: "#f7f7f7",
    minHeight: "100vh",
    padding: "60px 20px",
    display: "flex",
    justifyContent: "center",
  },
  container: {
    maxWidth: "900px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "40px 30px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    lineHeight: "1.7",
  },
  title: {
    fontSize: "24px",
    fontWeight: "700",
    textAlign: "center",
    marginBottom: "30px",
    color: "#222",
  },
  section: {
    marginBottom: "25px",
  },
  heading: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "8px",
  },
  text: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "10px",
  },
  list: {
    paddingLeft: "20px",
    color: "#555",
    fontSize: "14px",
    marginBottom: "10px",
  },
  link: {
    color: "#0056b3",
    textDecoration: "none",
  },
};

export default Cerez_Politikasi;
